import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchAttachmentDefinitionsTypes = getApiActionTypes(
  'DEVELOPMENT/FETCH_ATTACHMENT_DEFINITIONS',
);
export const updateAttachmentDefinitionsTypes = getApiActionTypes(
  'DEVELOPMENT/UPDATE_ATTACHMENT_DEFINITIONS',
);
